module.exports = __webpack_public_path__ + "static/media/YF48_5.bfb840e5.jpg";